import React, { Component } from "react";
import Preloader from "../layout/Preloader";
import BannerHome from "../layout/BannerHome";
import Brand from "../layout/Brand";
import AboutComponent from "../layout/AboutComponent";
import ProjectsShowcase from "../layout/ProjectsShowcase";
import Work from "../layout/Work";
import JobHistory from "../layout/JobHistory";
import Testimonials from "../layout/Testimonials";
import NewsletterSubscribe from "../layout/NewsletterSubscribe";
import ContactInformation from "../layout/ContactInformation";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import SEO from "../layout/SEO";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {toggleDarkMode} from "../../actions/preferenceActions";

class Home extends Component {

	componentDidMount() {
		window.resetScript();
	}

	render() {
		let { _preferences: preferences } = this.props;
		const authorName = preferences?._author || "Ahmed Karim";
		const description = `Portfolio de ${authorName} - Développeur et créateur de contenu. Découvrez mes projets, articles et veilles technologiques.`;

		return (
			<>
				<SEO
					title={authorName}
					description={description}
					keywords={`portfolio, ${authorName}, développement web, projets, articles`}
				/>
				<Header active={ "Accueil" }  />
				<Preloader />
				<BannerHome />

				<Brand />

				<AboutComponent />
				<ProjectsShowcase />
				<Work />
				<JobHistory />

				<Testimonials />

				<NewsletterSubscribe />

				<ContactInformation />

				<Footer />
			</>
		);
	}

}

Home.protoType = {
	_preferences: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	_preferences: state._preferences
});

export default connect(
	mapStateToProps,
	{ toggleDarkMode }
)(Home);